import script from "./ApprovalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalModal.vue?vue&type=style&index=0&id=9dd7743e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd7743e"]])

export default __exports__